import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { DocumentVersion } from './useDocumentVersions';

type CreateDocumentVersionPayload = {
  markdownContent: string;
  markdownContentWithMarkers?: string;
};

export function useCreateDocumentVersion(documentId?: string) {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: DocumentVersion }, Error, CreateDocumentVersionPayload>({
    mutationFn: (values: CreateDocumentVersionPayload) => {
      if (!documentId) throw new Error('documentId is required');
      return api.post<DocumentVersion>(`documents/${documentId}/versions`, values);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['documents', documentId, 'versions'] });
    },
  });

  const createDocumentVersion = async (values: CreateDocumentVersionPayload) => {
    if (!documentId) throw new Error('documentId is required');
    return mutateAsync(values);
  };

  return {
    createDocumentVersion,
    error,
    isLoading,
    reset,
  };
}
